<template>
  <nav v-if="!$route.meta.hideNav" class="navbar navbar-expand-lg">
    <div class="container-fluid" data-v="1743790037">
      <router-link class="navbar-brand" to="/" data-v="1756570056">{{  user.name }}</router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" data-v="1743790256">
            <router-link class="nav-link" :to="'/paintings'">{{ hh.t('paintings') }}</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/pages">Pages</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/contacts">Contacts</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/settings">Settings</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/feature-requests">Requests</router-link>
          </li>
        </ul>
        <ul class=" navbar-nav mb-2 mb-lg-0 align-items-center" data-v="1743849886">
          <li v-if="!isLoggedIn" class="nav-item" data-v="1756739808">
            <router-link class="nav-link" to="/login">Login</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item" data-v="1756739818">
            <router-link v-if="isAdmin" class="nav-link" to="/admin" data-v="1743942698">Admin</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item d-flex align-items-center gap-2" data-v="1756739820">
            <span class="navbar-text fw-semibold" :id="'user_id-' + user.id" data-n="1756es">{{ user.name }}</span>

            <!-- Bell icon -->
            <div v-if="unreadCount > 0" class="position-relative" ref="bellRef">
              <button class="btn btn-link p-0 nav-bell" @click="toggleNotifications" title="Notifications">
                <i class="bi bi-bell-fill fs-5"></i>
                <span v-if="unreadCount > 0" class="badge rounded-pill bg-danger nav-bell-badge">{{ unreadCount }}</span>
              </button>
              <div v-if="showNotifications" class="notifications-dropdown shadow">
                <div class="notifications-header d-flex justify-content-between align-items-center px-3 py-2">
                  <span class="fw-semibold">Notifications</span>
                  <button v-if="notifications.length" class="btn btn-link btn-sm p-0 text-muted" @click="markAllRead">Mark all read</button>
                </div>
                <div v-if="notifications.length === 0" class="px-3 py-3 text-muted text-center small">No new notifications</div>
                <ul v-else class="list-unstyled mb-0">
                  <li v-for="n in notifications" :key="n.id" class="notifications-item px-3 py-2 border-top">
                    <div class="small fw-semibold">{{ n.type === 'NewContactNotification' ? 'New Contact' : n.type }}</div>
                    <div class="small text-muted text-truncate" style="max-width:240px">{{ n.data.clientEmail }}</div>
                    <div class="small mt-1" style="max-width:260px;white-space:pre-wrap;word-break:break-word;max-height:48px;overflow:hidden">{{ n.data.text }}</div>
                    <div class="small text-muted mt-1">{{ hh.pDate(n.created_at) }}</div>
                  </li>
                </ul>
              </div>
            </div>

            <a v-if="user.url_name" :href="'/build/site/' + user.url_name" target="_blank" class="btn btn-outline-primary btn-sm">My Site</a>
            <router-link class="btn btn-outline-secondary btn-sm" to="/logout">Logout</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div v-if="!$route.meta.hideNav" id="flash-alert" class="flash-alert" style="display: none;" data-v="1755503924"></div>
  <div class="router-view-wrap">
    <router-view />
  </div>

  <footer v-if="isLoggedIn && !$route.meta.hideNav" class="app-footer" data-v="1755503924">
    <div class="container  text-muted small py-3">
        <a class="navbar-brand d-inline-flex align-items-center gap-1" href="/" data-n="ero872">
     &copy; {{ new Date().getFullYear() }} <img src="../../public/images/logos/logo.png" style="width: 16px; height: 16px;" class="img-fluid" alt="Logo" data-n="3ug3pt7">
    <span style="font-weight: bold;" data-n="hl60y40">Red Dot</span>
  </a> 

      {{ user.name }}
    </div>
  </footer>

  <div id="all-site-popup-w">
    <div id="all-site-popup">
      <div class="box-flex"></div>
      <div class="card" id="all-site-popup-iner">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span id="all-site-popup-title" class="fw-semibold">{{ popupTitle }}</span>
          <button id="all-site-popup-close" class="btn-close btn-close-white" @click="closePopup"></button>
        </div>
        <div class="card-body" id="all-site-popup-body"></div>
      </div>
      <div class="box-flex"></div>
    </div>
  </div>
</template>

<script>
import { provide, reactive, ref, watch, onMounted, onUnmounted } from 'vue'
import H from "./services/helpers.js"
import { storeToRefs } from 'pinia'
import { useUserStore } from './stores/userStore'


export default {
  components: {  },
  setup() {
    const hh = new H()
    provide('hh', hh)
    const userStore = useUserStore()
    const { user, isLoggedIn, isAdmin } = storeToRefs(userStore)
    const U = reactive({ user: user, isAdmin: isAdmin, isLoggedIn: isLoggedIn })
    provide('U', U)
    const popupTitle = ref('')
    const closePopup = () => { document.getElementById('all-site-popup-w').style.display = 'none'; popupTitle.value = '' }
    const openPopup = (title = '') => { popupTitle.value = title; document.getElementById('all-site-popup-w').style.display = 'block' }
    provide('closePopup', closePopup)
    provide('openPopup', openPopup)

    // Notifications
    const notifications = ref([])
    const unreadCount = ref(0)
    const showNotifications = ref(false)
    const bellRef = ref(null)

    const fetchNotifications = async () => {
      if (!isLoggedIn.value) return
      try {
        const re = await fetch('/api/notifications', {
          headers: { 'Authorization': 'Bearer ' + userStore.accessToken }
        }).then(r => r.json())
        notifications.value = re.notifications || []
        unreadCount.value = notifications.value.length
      } catch (e) { /* silent */ }
    }

    const markAllRead = async () => {
      await fetch('/api/notifications/mark-read', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + userStore.accessToken }
      })
      notifications.value = []
      unreadCount.value = 0
    }

    const toggleNotifications = () => {
      showNotifications.value = !showNotifications.value
    }

    const handleClickOutside = (e) => {
      if (bellRef.value && !bellRef.value.contains(e.target)) {
        showNotifications.value = false
      }
    }

    onMounted(() => {
      document.addEventListener('click', handleClickOutside)
      if (isLoggedIn.value) fetchNotifications()
    })
    onUnmounted(() => document.removeEventListener('click', handleClickOutside))

    watch(isLoggedIn, (v) => { if (v) fetchNotifications() })

    return { hh, user, isLoggedIn, isAdmin, closePopup, popupTitle, notifications, unreadCount, showNotifications, bellRef, toggleNotifications, markAllRead }
  },
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.router-view-wrap {
  flex: 1;
}
.app-footer {
  margin-top: 100px;
  border-top: 1px solid rgba(0,0,0,.1);
}
</style>
